// extracted by mini-css-extract-plugin
export default {"container":"SettingsSelect_container__dQZfG","tooltip":"SettingsSelect_tooltip__rRsB5"};